import { defineStore } from "pinia";
import { useLoadingState } from "@polargold/pg-frontend-vue";

export const useCheckoutSubmitLoadingStore = defineStore("checkoutSubmitLoadingStore", () => {
    const {
        isLoading,
        activateLoadingState: setLoadingState,
        deactivateLoadingState: resetLoadingState,
    } = useLoadingState();

    return { isLoading, setLoadingState, resetLoadingState };
});